// ── Color scheme ───────────────────────────────────────────────────────────
// Brand accents (Huttons Navy/Orange, Savills Yellow) stay constant across
// light & dark; surfaces/text follow the active MUI theme so the module
// honours the same dark/light toggle as Super Picker.
export interface PsfColors {
  navyDark: string; navy: string; navyLight: string;
  orange: string; orangeLight: string;
  yellow: string; yellowLight: string;
  surface: string; surfaceCard: string; surfaceElevated: string;
  border: string; borderAccent: string;
  text: string; textMuted: string;
  success: string; danger: string;
  headerBg: string; headerText: string;
}

export function buildPsfColors(mode: 'dark' | 'light', palette: any): PsfColors {
  const isDark = mode === 'dark';
  return {
    navyDark: '#001f43',
    navy: '#003580',
    navyLight: '#1a4f8a',
    orange: '#f47920',
    orangeLight: '#f9a64d',
    yellow: '#f5c518',
    yellowLight: '#ffe066',
    surface: palette.background.default,
    surfaceCard: palette.background.paper,
    surfaceElevated: isDark ? '#1a3050' : '#f2f5f9',
    border: palette.divider,
    borderAccent: 'rgba(244,121,32,0.4)',
    text: palette.text.primary,
    textMuted: palette.text.secondary,
    success: isDark ? '#2ecc71' : '#2e7d32',
    danger: isDark ? '#e74c3c' : '#d32f2f',
    // Header bar keeps Huttons navy in both modes for brand consistency.
    headerBg: '#001f43',
    headerText: 'rgba(255,255,255,0.92)',
  };
}
